import { render, staticRenderFns } from "./BI.vue?vue&type=template&id=06060eb0&scoped=true"
import script from "./BI.vue?vue&type=script&lang=js"
export * from "./BI.vue?vue&type=script&lang=js"
import style0 from "./BI.vue?vue&type=style&index=0&id=06060eb0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06060eb0",
  null
  
)

export default component.exports